import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import AccordionSlider from "@components/V2/Lab/AccordionSlider"
import { storyblokLinkToYocoLink } from "@utils/storyblok"

const AccordionSliderStoryblok = ({
  blok,
}: Storyblok.BlokProps<Storyblok.AccordionSlider>) => {
  return (
    <AccordionSlider
      backgroundColor={blok.backgroundColor}
      headingText={blok.headingText}
      headingBodyText={blok.headingBodyText}
      content={blok.content.map((item) => ({
        tabLabel: item.tabLabel,
        description: item.description,
        ctaText: item.ctaText,
        ctaLink: storyblokLinkToYocoLink(item.ctaLink),
        image: item.image.filename,
        imageAlt: item.image.alt,
        tags: item.tagCtas?.map((tag) => ({
          ctaText: tag.ctaText,
          ctaLink: storyblokLinkToYocoLink(tag.ctaLink)?.url ?? "",
        })),
      }))}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default AccordionSliderStoryblok
